<template>
  <div class="preloader">
    <img src="../assets/images/preloader.svg" />
  </div>
</template>

<script>
export default {
  name: "VPreloader"
};
</script>

<style scoped lang="scss">
.preloader {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 60px;
    height: 60px;
  }
}
</style>
